import store from '@/store'
/* eslint-disable */
// prettier-ignore
export default {
    paginas: {
        key: 'title',
        data: store.state.search.menuLinksAllowed,
    },
}
/* eslint-enable */
